export const GET_COMPETENCES_KEY = 'GET_COMPETENCES';
export const COMPETENCES_URL_PATH = '/api/v2/competences';
